import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import {
	BORDER_WIDTH,
	MODULAR_SHELVES,
	RACK_MATERIAL_COLORS,
	SHELF_CHUNKS_COUNT,
	SHELVE_MATERIAL_COLORS,
} from '@/shared/constants/configurator';
import { DISPLAY_SCALE } from '@/shared/constants/editor';
import { hexToRgba } from '@/shared/lib/styles';
import clsx from 'clsx';
import { SectionSideProps } from '../../types/section.types';
import styles from './top-section.module.css';

export const TopSection = ({ section, className, style, ...props }: SectionSideProps) => {
	const {
		state: { material },
	} = useConfigurator();

	const shelfDeck = section.selfs[0]?.deck;

	return (
		<div
			className={clsx(styles.wrapper, className)}
			style={{
				gap: MODULAR_SHELVES.includes(shelfDeck) ? 1 : 0,
				width: (section.width + BORDER_WIDTH * 2) * DISPLAY_SCALE,
				height: section.depth * DISPLAY_SCALE,
				borderColor: RACK_MATERIAL_COLORS[material],
				borderLeftWidth: BORDER_WIDTH * DISPLAY_SCALE,
				borderRightWidth: BORDER_WIDTH * DISPLAY_SCALE,
				backgroundColor: hexToRgba(SHELVE_MATERIAL_COLORS[shelfDeck], 0.7),
				...style,
			}}
			{...props}
		>
			{Array.from({ length: SHELF_CHUNKS_COUNT }).map((_, index) => (
				<div
					style={{ backgroundColor: SHELVE_MATERIAL_COLORS[shelfDeck] }}
					className={styles.shelfComponent}
					key={index}
				/>
			))}
		</div>
	);
};
